import React from 'react';

function Button({
  children,
  className = '',
  variant = 'primary',
  type = 'button',
  disabled = false,
  ...props
}) {
  const variants = {
    primary: 'bg-primary text-white shadow-sm hover:bg-teal-800 active:bg-teal-900',
    secondary: 'border border-slate-300 bg-white text-ink shadow-sm hover:border-slate-400 hover:bg-slate-50',
    ghost: 'bg-transparent text-slate-700 hover:bg-slate-100 hover:text-primary',
    danger: 'border border-transparent bg-transparent text-red-700 hover:border-red-200 hover:bg-red-50'
  };
  const variantClass = variants[variant] || variants.primary;

  return (
    <button
      type={type}
      disabled={disabled}
      aria-disabled={disabled || undefined}
      className={`inline-flex min-h-11 touch-manipulation items-center justify-center gap-2 rounded-xl px-4 py-2.5 text-sm font-semibold leading-5 transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 active:translate-y-px disabled:cursor-not-allowed disabled:opacity-60 disabled:active:translate-y-0 motion-reduce:transition-none ${variantClass} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}

export default Button;